module.exports = __webpack_public_path__ + "static/media/DGA-คู่มือการใช้โปรแกรมที่พัฒนาและปรับปรุง-ส่วนภูมิภาค_v2.26c63150.pdf";